import React from 'react';
import { Card, Row, Col, Tag, Typography, Flex, Button } from 'antd';
import useAllVehicleTypes from '../../../hooks/useAllVehicleType';
import useAllVehicles from '../../../hooks/useAllVehicle';
import vehicleImage from '../../../assets/images/vehicle.png';

const { Text, Title } = Typography;

const FALLBACK_IMAGE = 'https://plus.unsplash.com/premium_photo-1664302152991-d013ff125f3f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YnVzfGVufDB8fDB8fHww';

const VehicleCard = ({ vehicleType, selected, onClick }) => {
    return (
        <Card
            className={`vehicle-card ${selected ? 'selected' : ''}`}
            onClick={() => onClick(vehicleType)}
            hoverable
            styles={{ body: { padding: 16, height: '100%' } }}
            style={{ 
                borderRadius: 16,
                background: '#FFFFFF',
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
                margin: 0,
                height: '100%'
            }}
        >
            <Row gutter={[16, 16]} style={{height: '100%'}}>
                <Col span={10}>
                    <img 
                        src={vehicleType.image || vehicleImage} 
                        alt={vehicleType.vehicleTypeName}
                        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 8, border: '1px solid #E9E6FA' }}
                    />
                </Col>
                <Col span={14} style={{display: 'flex', flexDirection: 'column', gap: '8px', justifyContent: 'space-between'}}>
                    <Title level={4} style={{ margin: 0, fontWeight: 500, fontSize: 16 }}>{vehicleType.vehicleTypeName}</Title>
                    <Text type="secondary" className='d-block' style={{ fontSize: 14 }}>Up to {vehicleType.capacity} passengers</Text>
                    {/* <Text type="secondary" className='d-block' style={{ fontSize: 14 }}>Registration: {vehicleType.vehicleRego}</Text> */}
                    <Flex gap={4} className='flex-wrap'>
                        {vehicleType.features.map(feature => (
                            <Tag color="#F3F4F6" className='mr-0' style={{color: '#1A1A1A',borderRadius: 20, fontSize: 13}}>{feature}</Tag>
                        ))}
                    </Flex>
                    <Flex justify="space-between" align="center">
                        <div>
                            {vehicleType.vehicleStatus && (
                                <Tag color={vehicleType.vehicleStatus === 'Active' ? 'success' : 'error'} style={{borderRadius: 20, fontSize: 13}}>{vehicleType.vehicleStatus}</Tag>
                            )}
                            {/* <Title level={3} style={{ margin: 0 }}>${vehicle.pricePerDay}</Title>
                            <Text type="secondary">per day</Text> */}
                        </div>
                        <Button 
                            type={selected ? "default" : "primary"}
                            style={{ 
                                borderRadius: 24,
                                background: selected ? '#E9E6FA' : '#6B54F9',
                                outline: 'none'
                            }}
                        >
                            {selected ? 'Selected' : 'Select'}
                        </Button>
                    </Flex>
                </Col>
            </Row>
        </Card>
    );
};

const VehicleStep = ({ data, onChange }) => {
    const { allVehicleTypesArray } = useAllVehicleTypes();

    const handleVehicleSelect = (vehicle) => {
        const isSelected = data.some(v => v.vehicleTypeId === vehicle.vehicleTypeId);
        if (isSelected) {
            onChange(data.filter(v => v.vehicleTypeId !== vehicle.vehicleTypeId));
        } else {
            onChange([...data, vehicle]);
        }
    };

    return (
        <div>
            {/* <Flex className='mb-3' align={'center'} style={{gap: 8}}>
                <Tag color="#6B54F9" className='mr-0' style={{fontWeight: 500,borderRadius: 20, fontSize: 14}}>All</Tag>
                <Tag color="#C1C5CE" className='mr-0' style={{fontWeight: 500,borderRadius: 20, fontSize: 14}}>Wheelchair</Tag>
                <Tag color="#C1C5CE" className='mr-0' style={{fontWeight: 500,borderRadius: 20, fontSize: 14}}>AC</Tag>
                <Tag color="#C1C5CE" className='mr-0' style={{fontWeight: 500,borderRadius: 20, fontSize: 14}}>WiFi</Tag>
                <Tag color="#C1C5CE" className='mr-0' style={{fontWeight: 500,borderRadius: 20, fontSize: 14}}>Restroom</Tag>
            </Flex> */}
            <Row gutter={[16, 16]}>
                {allVehicleTypesArray.map(vehicleType => (
                    <Col xs={24} md={12} key={vehicleType.vehicleTypeId}>
                        <VehicleCard
                            vehicleType={vehicleType}
                            selected={data.some(v => v.vehicleTypeId === vehicleType.vehicleTypeId)}
                            onClick={handleVehicleSelect}
                        />
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default VehicleStep; 